module.exports = __webpack_public_path__ + "static/media/StandingTallENG.91ec4ca9.vtt";